import React, { ReactElement } from 'react';
import {
    Avatar, Paper, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, AccordionDetails, AccordionSummary, Accordion, Typography,
} from '@material-ui/core';
import { convertToHex } from '../../utils/ColorUtils';
import { createStyles, makeStyles, useTheme } from '@material-ui/core/styles';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { AlmeConfig } from '../../models/AlmeConfig';

const useStyles = makeStyles(() =>
    createStyles({
        root: {
            width: '60%',
        },
    }),
);

interface AlmeIconColorToolProps {
    almeConfig: AlmeConfig;
    names?: string[];
}

export default function AlmeIconColorTool(props: AlmeIconColorToolProps): ReactElement {
    const classes = useStyles();
    const theme = useTheme();

    const names = props.names || [
        "Rachel Green",
        "Joey Tribbiani",
        "Ross Geller",
        "Monica Geller",
        "Ben Geller",
        "Emma Geller-Green",
        "Chandler Bing",
        "Phoebe Buffay",
        "Ursula Buffay",
        "Janice Hosenstein",
        "Gunther",
        "Richard Burke",
        "Kathy",
        "Emily Waltham",
        "Sarah Tuttle",
        "Jill Green",
        "Charlie Wheeler",
    ];

    let defaultIcon = props.almeConfig.history.liveChatResponse.liveChatOperatorResponse.chatIcon;
    if (defaultIcon) {
        defaultIcon = React.cloneElement(defaultIcon, { alt: 'Default', title: 'Default' });
    }

    return (
        <div className={classes.root}>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel-icon-color-tool-content"
                    id="panel-icon-color-tool-header"
                >
                    <Typography variant='h6'>Icon Colors</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Name</TableCell>
                                    <TableCell>Color Code Hex</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell component="th" scope="row">Default Icon</TableCell>
                                    <TableCell component="th" scope="row">
                                        {defaultIcon}
                                    </TableCell>
                                </TableRow>
                                {names.map((name, i) => {
                                    const colorCodeHex = theme.palette.augmentColor({ main: convertToHex(name) });
                                    return (
                                        <TableRow key={name}>
                                            <TableCell component="th" scope="row">
                                                {name}
                                            </TableCell>
                                            <TableCell>
                                                <Avatar style={{ backgroundColor: colorCodeHex.main, color: colorCodeHex.contrastText }} alt={name} title={name}>{name.charAt(0)}</Avatar>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </AccordionDetails >
            </Accordion>
        </div>
    );
}